import { htmlToJson } from "./htmlToJson";
import { enqueueSnackbar } from "notistack";
import keycloak from "../../keycloak";
import { BACKEND_URL } from "../../global";

export function saveJson(id, unsetChangeListener) {
    const data = {
        annotation: htmlToJson(document.getElementById('hypertranscript')),
    };

    fetch(`${BACKEND_URL}/asr_results/${id}`, {
        method: 'PATCH',
        body: JSON.stringify(data),
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${keycloak.token}`
        },
    })
        .then(
            (response) => {
                if (response.status != 200) {
                    enqueueSnackbar('Δεν ήταν δυνατή η αποθήκευση, αποθηκεύστε το αρχείο τοπικά και προσπαθήστε ξανά αργότερα', { variant: 'warning', autoHideDuration: 12000 })
                } else {
                    enqueueSnackbar('Οι αλλαγές αποθηκεύτηκαν με επιτυχία', { variant: 'success', autoHideDuration: 3000 })
                    unsetChangeListener();
                }
            },
            (error) => {
                console.log(error);
                enqueueSnackbar('Δεν ήταν δυνατή η αποθήκευση, αποθηκεύστε το αρχείο τοπικά και προσπαθήστε ξανά αργότερα', { variant: 'warning', autoHideDuration: 12000 })
            },
        );
}

export default saveJson;